import { useEffect, useRef } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import {
  columntype,
  dataLocalStorage,
  getLocalStorage,
  inputType,
  isValidArray,
} from "src/helper/publicFunction";
import DynamicModal from "src/components/modal/DynamicModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";
import { DeleteTeam, EditTeam, GetTeam, ManageTeam } from "./actions";

const Team = () => {
  const dispatch = useDispatch();
  const Commonalert = CommonAlert(); // Create an alert object using the function
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [array, setarray] = useState([]);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [mediaTypes, setMediaTypes] = useState([]);
  const [TotalData, setTotalData] = useState(0);
  let dataPrivileges = getLocalStorage(dataLocalStorage.privileges);

  const Schema = Yup.object().shape({
    name: Yup.string().trim().required("required"),
    position_title: Yup.string().trim().required("required"),
    // position_description: Yup.string().trim(),
    image: Yup.string().trim().required("required"),
    bio: Yup.string().trim().required("required"),
    // certificates: Yup.string().trim().required("required"),
    // certificates: Yup.string().trim().required("required"),
  });

  const GetData = ({ tableName = null, type = null }) => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetTeam({
        page: page,
        rowsPerPage: rowsPerPage,
        callback: (data) => {
          if (isValidArray(data?.data)) {
            setData(data?.data);
            setTotalData(data?.count);
            setarray([
              {
                failed: "id",
                type: inputType.text,
                title: "id",
                placeholder: "",
                fullwidth: true,
                customdesign: { display: "none" },
              },
              {
                failed: "sort_order",
                type: inputType.number,
                title: "Sort Order",
                placeholder: "",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
              {
                failed: "name",
                type: inputType.text,
                title: "Name",
                placeholder: "",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
              {
                failed: "email",
                type: inputType.email,
                title: "Email",
                placeholder: "",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
              {
                failed: "position_title",
                type: inputType.text,
                title: "Position (Title)",
                placeholder: "",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
              {
                failed: "position_description",
                type: inputType.text,
                title: "Position (Description)",
                placeholder: "",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
              {
                failed: "image",
                type: inputType.image,
                title: "Media",
                placeholder: "",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
              {
                failed: "bio",
                type: inputType.text,
                title: "Biography",
                placeholder: "",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
              {
                failed: "info",
                type: inputType.editor,
                title: "Information",
                placeholder: "",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
              {
                failed: "certificates",
                type: inputType.editor,
                title: "Certificates",
                placeholder: "",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
              {
                failed: "facebook_link",
                type: inputType.text,
                title: "Facebook Link",
                placeholder: "",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
              {
                failed: "instagram_link",
                type: inputType.text,
                title: "Instagram Link",
                placeholder: "",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
              {
                failed: "x_link",
                type: inputType.text,
                title: "X Link",
                placeholder: "",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
              {
                failed: "youtube_link",
                type: inputType.text,
                title: "YouTube Link",
                placeholder: "",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
            ]);
          } else {
            setData([]);
            setTotalData(0);
          }
          setLoadingData(false);
        },
      })
    );
  };

  useEffect(() => {
    GetData({ tableName: null, type: null });
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.number, name: "sort_order" },
    { type: columntype.image, name: "image" },
    { type: columntype.text, name: "name" },
    { type: columntype.text, name: "email" },
    { type: columntype.text, name: "position_title" },
    { type: columntype.text, name: "position_description", limitText: true },
    { type: columntype.text, name: "bio", limitText: true },
    // { type: columntype.text, name: "info" },
    // { type: columntype.text, name: "certificates" },
    // { type: columntype.text, name: "facebook_link" },
    // { type: columntype.text, name: "instagram_link" },
    // { type: columntype.text, name: "x_link" },
    // { type: columntype.text, name: "youtube_link" },
    { type: columntype.switch, name: "is_active" },
    { type: columntype.switch, name: "is_therapist" },
  ];

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "id",
      withSort: false,
    },
    {
      id: "sort_order",
      numeric: false,
      disablePadding: false,
      label: "Sort Order",
      withSort: false,
    },
    {
      id: "image",
      numeric: false,
      disablePadding: false,
      label: "Media",
      withSort: true,
    },
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "Name",
      withSort: false,
    },
    {
      id: "email",
      numeric: false,
      disablePadding: false,
      label: "Email",
      withSort: false,
    },
    {
      id: "position_title",
      numeric: false,
      disablePadding: false,
      label: "Position (Title)",
      withSort: false,
    },
    {
      id: "position_description",
      numeric: false,
      disablePadding: false,
      label: "Position (Description)",
      withSort: false,
    },

    {
      id: "bio",
      numeric: false,
      disablePadding: false,
      label: "Biography",
      withSort: false,
    },
    // {
    //   id: "certificates",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "Certificates",
    //   withSort: false,
    // },
    // {
    //   id: "facebook_link",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "FB Link",
    //   withSort: false,
    // },
    // {
    //   id: "instagram_link",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "IG Link",
    //   withSort: false,
    // },
    // {
    //   id: "x_link",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "X Link",
    //   withSort: false,
    // },
    // {
    //   id: "youtube_link",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "YT Link",
    //   withSort: false,
    // },
    // {
    //   id: "info",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "Information",
    //   withSort: false,
    // },
    {
      id: "is_active",
      numeric: false,
      disablePadding: false,
      label: "Is active",
      withSort: true,
    },
    {
      id: "is_therapist",
      numeric: false,
      disablePadding: false,
      label: "Therapist",
      withSort: true,
    },
    (dataPrivileges["25"]?.access_edit == 1 ||
      dataPrivileges["25"]?.access_delete == 1) && {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
      withSort: false,
    },
  ];

  const List = [
    dataPrivileges["25"]?.access_delete === 1 && {
      name: "Delete",
      function: async (row) => {
        if (row) {
          Commonalert.show({
            title: `Are you sure to delete "${row?.name ?? ""}"?`,
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteTeam({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      id: [row.id],
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }
      },
    },
    dataPrivileges["25"]?.access_edit === 1 && {
      name: "Edit",
      function: async (data) => {
        setEditMode(true);
        setvalues(data);
        setShowModal(true);
      },
    },
  ];

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
    dispatch(
      EditTeam({
        id: row?.id,
        dataFailed: newData,
        nameFailed: failedName,
        callback: () => {
          updateDataLocal({ id: row.id, failedName, newData });
        },
      })
    );
  };

  const updateDataLocal = ({ id, failedName, newData }) => {
    setData((prevData) => {
      return prevData.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            [failedName]: newData,
          };
        }
        return item;
      });
    });
    setloadingEditdatatype("");
  };

  const debounceRef = useRef(null);

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearch(value);

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      if (value === "" || !value) {
        return;
      }

      dispatch(
        GetTeam({
          rowsPerPage,
          page,
          search: value, // Use latest value directly
          callback: (data) => {
            console.log({ data123123: data });
            if (data) {
              setData(data?.data);
            }
          },
        })
      );
    }, 1000);
  };

  return (
    <>
      <DynamicTable
        handleSearch={handleSearch} // call api
        onRequestSort={(tableName, type) => {
          if (tableName && type) {
            GetData({ tableName, type });
          }
        }} // call api
        onPressDelete={(valueId) => {
          Commonalert.show({
            title: "Are you sure?",
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteTeam({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      id: valueId,
                    })
                  ),

                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }} // call api
        onPressItem={(row) => {}} // when press item
        onPressAnyAction={(row, failedName, newData) => {
          updateDataApi({ row, failedName, newData });
        }} // when press checkbox or switch
        onPressAdd={() => {
          setvalues({});
          setEditMode(false);
          setShowModal(true);
        }} // when press add new button show modal to add new item
        items={data} // all data
        columns={columns} // type of data
        headCells={headCells} // columns name
        page={page} // number of page from api
        setPage={setPage} // set number of page from api
        selected={selected} // selected items
        setSelected={setSelected} // set selected items
        search={search} // search failed
        rowsPerPage={rowsPerPage} // number show Data
        setRowsPerPage={setRowsPerPage} // set number show data
        Listdropdown={List} // list action with function
        withOption={true} // for remove action column
        loadingData={loadingData} // when load data from api
        rowsPerPageOptions={[5, 10, 25, 50]} // set option number of show data
        totalItem={TotalData} // total data without pagination
        loadingEditdatatype={loadingEditdatatype} // first failed (id) and second (failed Name) like ={"1-is_active"}
        withAddButton={dataPrivileges["25"]?.access_write === 1}
        withDeleteItem={dataPrivileges["25"]?.access_delete === 1}
        withEditItem={dataPrivileges["25"]?.access_edit === 1}
        withPagination={true}
        withSearch={true}
      />
      {showModal ? (
        <DynamicModal
          show={showModal}
          setShow={setShowModal}
          faileds={array}
          values={values}
          title={"Team"}
          editMode={editMode}
          description={editMode ? "Edit" : "Add new Team Member"}
          buttonTitle={editMode ? "Edit" : "Add"}
          onSubmit={(valuess) => {
            dispatch(
              ManageTeam({
                editMode: editMode,
                values: valuess,
                callback: (res) => {
                  if (res) {
                    setShowModal(false);
                    GetData({ tableName: null, type: null });
                  }
                },
              })
            );
          }}
          Schema={Schema}
        />
      ) : null}
    </>
  );
};

export default Team;
